var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#D32F2F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 14.875C17.0938 15.375 17.0938 16.1562 16.625 16.6562C16.125 17.125 15.3438 17.125 14.8438 16.6562L12 13.7812L9.125 16.6562C8.625 17.125 7.84375 17.125 7.34375 16.6562C6.875 16.1562 6.875 15.375 7.34375 14.875L10.2188 12L7.34375 9.15625C6.875 8.65625 6.875 7.875 7.34375 7.375C7.84375 6.90625 8.625 6.90625 9.125 7.375L12 10.25L14.8438 7.375C15.3438 6.90625 16.125 6.90625 16.625 7.375C17.0938 7.875 17.0938 8.65625 16.625 9.15625L13.75 12L16.625 14.875Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRecharge);
export default __webpack_public_path__ + "static/media/cancel-recharge.e083bc64886fc0345e216d5f411033ce.svg";
export { ForwardRef as ReactComponent };